interface RankingItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'same';
  imageUrl: string;
  imageAlt: string;
}

const rankingItems: RankingItem[] = [
  {
    rank: 1,
    title: '重生之逆天改命',
    tag: '韩漫 · 穿越',
    heat: '1562万',
    trend: 'up',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20illustration%20of%20a%20determined%20female%20character%2C%20elegant%20and%20powerful%20expression%2C%20warm%20amber%20and%20deep%20red%20colors%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style%2C%20high%20quality&width=120&height=160&seq=rank-01&orientation=portrait',
    imageAlt: '重生之逆天改命',
  },
  {
    rank: 2,
    title: '霸道总裁的契约新娘',
    tag: '韩漫 · 恋爱',
    heat: '1438万',
    trend: 'up',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20illustration%20of%20a%20beautiful%20couple%2C%20elegant%20and%20stylish%2C%20warm%20pink%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%2C%20high%20quality&width=120&height=160&seq=rank-02&orientation=portrait',
    imageAlt: '霸道总裁的契约新娘',
  },
  {
    rank: 3,
    title: '咒术战线',
    tag: '日漫 · 热血',
    heat: '1285万',
    trend: 'same',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20cover%20illustration%20of%20a%20fighter%20with%20glowing%20energy%2C%20intense%20action%20pose%2C%20warm%20orange%20and%20dark%20tones%2C%20clean%20simple%20background%2C%20shonen%20manga%20cover%20style%2C%20high%20quality&width=120&height=160&seq=rank-03&orientation=portrait',
    imageAlt: '咒术战线',
  },
  {
    rank: 4,
    title: '剑道至尊',
    tag: '国漫 · 玄幻',
    heat: '1103万',
    trend: 'up',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20illustration%20of%20a%20swordsman%20in%20flowing%20robes%2C%20misty%20mountain%20background%2C%20warm%20earthy%20tones%2C%20clean%20simple%20composition%2C%20ink%20wash%20style%2C%20high%20quality&width=120&height=160&seq=rank-04&orientation=portrait',
    imageAlt: '剑道至尊',
  },
  {
    rank: 5,
    title: '放学后的秘密',
    tag: '日漫 · 校园',
    heat: '976万',
    trend: 'down',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20gentle%20Japanese%20manga%20cover%20illustration%20of%20school%20students%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20tones%2C%20clean%20simple%20background%2C%20shojo%20manga%20style%2C%20high%20quality&width=120&height=160&seq=rank-05&orientation=portrait',
    imageAlt: '放学后的秘密',
  },
];

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-line', color: 'text-accent-500' };
    if (trend === 'down') return { icon: 'ri-arrow-down-line', color: 'text-secondary-400' };
    return { icon: 'ri-subtract-line', color: 'text-foreground-400' };
  };

  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门榜单</h2>
          <p className="text-sm text-foreground-500">本周阅读热度排行榜，看看大家都在追什么</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item) => {
              const trend = trendIcon(item.trend);
              return (
                <div
                  key={item.rank}
                  className="flex items-center gap-4 p-4 border-b border-background-200/40 last:border-b-0 hover:bg-background-100/60 transition-colors cursor-pointer"
                >
                  <div className="flex-shrink-0 w-8 text-center">
                    <span
                      className={`text-lg font-bold ${
                        item.rank <= 3 ? 'text-accent-500' : 'text-foreground-400'
                      }`}
                    >
                      {item.rank}
                    </span>
                  </div>

                  <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={item.imageUrl}
                      alt={item.imageAlt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-foreground-900">{item.title}</div>
                    <div className="text-xs text-foreground-500 mt-0.5">{item.tag}</div>
                  </div>

                  <div className="flex-shrink-0 text-right">
                    <div className="text-sm font-bold text-foreground-800">{item.heat}</div>
                    <div className="flex items-center justify-end gap-1 mt-0.5">
                      <span className="text-xs text-foreground-500">周热度</span>
                      <i className={`${trend.icon} text-xs ${trend.color}`}></i>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}